export default {
  data: {
    oldpassword: "",
    password: "",
    repassword: "",
  },
  //type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
  rule: {
    oldpassword: {
      type: "password",
      message: "原密码不合法，6-16位，必须含字母",
    },
    password: {
      type: "password",
      message: "新密码不合法，6-16位，必须含字母",
    },
    repassword: {
      type: "password",
      message: "确认密码不合法，6-16位，必须含字母",
    },
  },
};
